export default {
  path: '/',
  name: 'Default',
  component: () => import('../views/layouts/Default.layout.vue'),
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: '/',
      name: 'Home',
      component: () => import('../views/pages/Home/Home.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'pdf',
      name: 'PDF',
      component: () => import('../views/pages/Home/Pdf.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'releasenote',
      name: 'releasenote',
      component: () => import('../views/pages/Home/ReleaseNote.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'employee-search',
      name: 'EmployeeSearch',
      component: () => import('../views/pages/Home/Employee.page.vue'),
      meta: {
        requiresAuth: true
      }
    }
  ]
}
